// extracted by mini-css-extract-plugin
module.exports = {"buttonBordered":"Styles_buttonBordered__1Wso7","buttonColored":"Styles_buttonColored___5TKl"};